import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ListIcon from '@material-ui/icons/List';
import PaymentIcon from '@material-ui/icons/Payment';
import invoicingOpenPaymentIcon from 'assets/menu-list-icon/invoicing-open-icon.svg';
import invoicingOverviewIcon from 'assets/menu-list-icon/invoicing-overview-icon.svg';
import { EmptyStateWithText } from 'components/EmptyState';
import routePaths from 'constants/route-paths';
import { Namespace } from 'locales';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AsideListIconComponent, { AsideListIcon } from '../common/AsideIconMenuItem';

const InvoicingAsideMenu = () => {
  const { t } = useTranslation(Namespace.invoicing);

  const asideListIcons: AsideListIcon[] = [
    {
      label: t('invoices'),
      routePath: routePaths.INVOICING_OVERVIEW,
      svgIcon: invoicingOverviewIcon,
    },
    {
      label: t('openPayments'),
      routePath: routePaths.INVOICING_OPEN,
      svgIcon: invoicingOpenPaymentIcon,
    },
    {
      label: t('balances'),
      routePath: routePaths.INVOICING_BALANCES,
      muiIcon: AccountBalanceIcon,
    },
    {
      label: t('incomes_by_cost_type'),
      routePath: routePaths.INVOICING_INCOMES,
      muiIcon: PaymentIcon,
    },
    {
      label: t('careLevelList'),
      routePath: routePaths.INVOICING_CARE,
      muiIcon: AttachMoneyIcon,
    },
    {
      label: t('residentsWithoutInvoiceMenuItem'),
      routePath: routePaths.RESIDENTS_WITHOUT_INVOICE,
      muiIcon: ListIcon,
    },
    {
      label: t('cash_balance'),
      routePath: routePaths.INVOICING_CASH_BALANCE,
      muiIcon: PaymentIcon,
    },
    {
      label: t('sepa_menu_label'),
      routePath: routePaths.SEPA,
      muiIcon: ListIcon,
    },
    {
      label: t('sepa_pocket_title'),
      routePath: routePaths.SEPA_POCKET,
      muiIcon: ListIcon,
    },
    {
      label: t('fibu_menu_label'),
      routePath: routePaths.FIBU,
      muiIcon: ListIcon,
    },
    {
      label: t('fibu_cash_menu_label'),
      routePath: routePaths.FIBU_CASH,
      muiIcon: ListIcon,
    },
  ];

  const [chosen, setChosen] = useState<string>();

  return (
    <div className="aside-menu">
      <ul className="menu-nav py-0">
        {asideListIcons.length ? (
          asideListIcons.map((listItem) => (
            <AsideListIconComponent
              key={listItem.label}
              icon={listItem}
              active={listItem.label === chosen}
              onClick={() => setChosen(listItem.label)}
            />
          ))
        ) : (
          <EmptyStateWithText text={t('no_results_for_current_settings')} verticalPositionTop />
        )}
      </ul>
    </div>
  );
};

export default InvoicingAsideMenu;
